import { render, staticRenderFns } from "./addDouSchoolJob.vue?vue&type=template&id=f2896f78&scoped=true"
import script from "./addDouSchoolJob.vue?vue&type=script&lang=js"
export * from "./addDouSchoolJob.vue?vue&type=script&lang=js"
import style0 from "./addDouSchoolJob.vue?vue&type=style&index=0&id=f2896f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2896f78",
  null
  
)

export default component.exports